// ============================================================
// THE AMORPHOUS HEAD - a low-poly outline whose points drift, never the
// same twice (ruling 2026-10-07, the "Amorphous" page). Each point has its
// own seeded phase and speed (`rngFor`, never Math.random: gotcha 5), so a
// figure keeps its own wobble and two blobs never move in step.
//
// Pure. Zero React dependency.
// ============================================================
import { between, rngFor } from './rng';

const POINTS = 7;
/** How far a point strays from the round head, as a share of its radius. */
const STRAY = 0.3;

/**
 * The head's outline in screen space around `centre`, of radius `r`, at time
 * `t` seconds: seven points, each breathing in and out on its own.
 */
export function blobOutline(id: string, centre: { x: number; y: number }, r: number, t: number) {
  const rng = rngFor(id, 'blob');
  return Array.from({ length: POINTS }, (_, i) => {
    const phase = between(rng, 0, Math.PI * 2);
    const speed = between(rng, 0.6, 1.4);
    const a = (i / POINTS) * Math.PI * 2;
    const k = 1 + STRAY * Math.sin(t * speed + phase);
    return { x: centre.x + Math.cos(a) * r * k, y: centre.y + Math.sin(a) * r * k };
  });
}
